import {createAction, props} from '@ngrx/store';
import {OrderPagedResponse} from '@app/marketplace/orders/_models/order.interface';

export const LOADING_ORDERS = '[Orders] Loading orders items';
export const LIST_ORDERS = '[Orders] List orders items';
export const ERROR_ORDERS = '[Orders] Orders Loaded Error';
export const CANCEL_ORDERS_REQUEST = '[Orders] Cancel orders request';

export const LoadingOrdersAction = createAction(
  LOADING_ORDERS,
  props<{ payload: any }>()
);
export const ListOrdersAction = createAction(
  LIST_ORDERS,
  props<{ data: OrderPagedResponse }>()
);
export const CancelOrderRequestAction = createAction(CANCEL_ORDERS_REQUEST);
